var desensitizeEnglishName = function (item) {
  var english_surname = item.english_surname;
  var english_name = item.english_name;
  return english_surname && english_name ? english_surname + '/' + english_name : english_surname || english_name;
};

var desensitize = function (data, star = 0, end = data.length) {
  if (end < 0) {
    end = end + data.length;
  }

  const len = Math.abs(end - star);
  return data.substring(0, star) + '*'.repeat(len) + data.substring(end);
};

var desensitizeCardId = function (val, key) {
  if (val.length < 10) {
    return desensitize(val, 2, -2);
  }

  if (val.length < 15) {
    return desensitize(val, 4, -2);
  }

  return desensitize(val, 6, -2);
};

var desensitizePhone = function (phone) {
  // 不再补全手机号
  // phone = ('' + phone).padStart(11, '0');
  phone = phone + '';

  if (phone.length > 8) {
    return desensitize(phone, 3, -4);
  } else if (phone.length === 8) {
    return desensitize(phone, 3, -3);
  } else {
    return desensitize(phone, 2, -2);
  }
};

var checkRequire = function (cardTypes, selectedCardList) {
  let required = false;
  let arrList = [...selectedCardList];
  arrList.forEach(item => {
    if (item && cardTypes.includes('' + item.card_type)) {
      required = true;
      return;
    }
  });
  return required;
};

var hasRequired = function (cardTypes, selectedCardList, isRequired, isNeedCard) {
  let cardList = [];

  if (isNeedCard) {
    cardList = selectedCardList;
  }

  return checkRequire(cardTypes, cardList) || isRequired;
};

var isMissing = function (data, need_card, config) {
  let configKey = Object.keys(config || {});
  let isCardExpiredShow = config['expire_date'] && data.card_list && hasRequired(config['expire_date'].requiredcCrdTypes || [], [data.card_list[0]], config['expire_date'].isRequired, need_card); //1、证件:需要证件但是没有证件号或者除身份证以为的证件，没有证件有效期
  //2、国际业务中: 英文姓名、手机号、出生日期、性别、国际必填
  //3、国内业务中: 中文名、手机号必填

  let isCardMissing = need_card === '1' && (data.card_list && data.card_list.length == 0 || data.card_list && data.card_list.length > 0 && (!data.card_list[0].id_no || data.card_list[0].card_type !== '1' && data.card_list[0].expire_date === '' && isCardExpiredShow)); // passenger_name:'es-contact-name',
  // english_surname:'es-english-surname',
  // english_name:'es-english-name',
  // contact_phone:'es-contact-phone',
  // birth_date:'es-birth-date',
  // sex:'es-contact-sex',
  // nickname:'es-contact-nickname',
  // remark:'es-contact-remark',
  // nationlity:'es-nationlity'

  let isOtherMissing = false;
  configKey.map(item => {
    let card_list = data?.card_list?.[0] ? [data.card_list[0]] : [];
    let isRequired = hasRequired(config[item]?.requiredcCrdTypes || [], card_list, config[item]?.isRequired, need_card == '1');

    if (config[item] && isRequired && (data[item] === '' || data[item] === '0') && item !== 'nationlity') {
      isOtherMissing = true; //如果是不需要证件的时候,名字必填，不计入，后面另外判断

      if (need_card === '0' && ['passenger_name', 'english_surname', 'english_name'].includes(item) !== -1) {
        isOtherMissing = false;
      }
    }

    if (config[item] && item === 'nationlity' && !data.country_code && isRequired) {
      isOtherMissing = true;
    }
  }); //如果是不需要证件的时候,并且中文名、英文姓名都没有的时候为true

  if (need_card === '0' && !data.passenger_name && (!data.english_surname || !data.english_name)) {
    isOtherMissing = true;
  }

  return isCardMissing || isOtherMissing;
};

var isEmployee = function (item) {
  var sub_type = item.sub_type;
  return sub_type == '1';
};

var isMySelf = function (item, phone) {
  return item.encrypt_phone == phone;
};

var isExternal = function (item) {
  var sub_type = item.sub_type;
  return sub_type == '2' || sub_type == '3';
};

var isItemChecked = function (data, listSelected) {
  var id = data.id;
  var passenger_name = data.passenger_name;
  var passenger_type = data.passenger_type;
  var passenger_source = data.passenger_source;
  var id_no = data.id_no;
  const index = listSelected.findIndex(function (item) {
    let _same = false;

    if (passenger_source == 0) {
      // 12306
      _same = true;
    } else if (passenger_source == 1) {
      // 本地乘车人
      _same = passenger_type == item.passenger_type;
    }

    return item.passenger_name == passenger_name && item.id_no == id_no && item.passenger_source == passenger_source && _same;
  });
  return index > -1;
};

var isDisableSelect = function (data, listSelected, maxContact, need_card, config) {
  // 国际出行人需求后，产品要求干掉相同手机号检验，因为可能是一个人帮多人代订，填的一个手机号
  // const phoneIndex = listSelected.findIndex(function(item) {
  // return item.id == data.id && item.card_type == data.card_type
  //   return item.contact_phone == data.contact_phone
  // });
  const idIndex = listSelected.findIndex(function (item) {
    return item.id == data.id; // return item.contact_phone == data.contact_phone
  }); // 新增国籍后添加护照和外国人永久居留证缺失国籍的检验
  // let card_list = (data && data.card_list) || []
  // let firstCard = card_list[0] || {}
  // let hasCountry = true
  // let card_type = Number(firstCard.card_type)
  // if([2,7].includes(card_type) && !firstCard.country_code && category == Category.train){
  //   hasCountry = false
  // }
  //这块需要 todo 机票没有国籍可以选择 只有火车票不能选择 火车票下单需要国籍 整改先去掉 后续再沟通

  let hasAllData = isMissing(data, need_card, config); // 机票品类需要证件，但是没有证件号 || 超过最大可选人数 || 手机号相同，但id不相同 || 已离职 （原来逻辑）
  // return hasAllData
  // || (listSelected.length === maxContact && idIndex !== -1) 
  // // || (phoneIndex !== -1 && idIndex === -1)
  // || data.status == '4'
  // // || !hasCountry
  // 非已选择出行人 && (需要证件，但是没有证件号 || 超过最大可选人数 || 已离职）

  return idIndex === -1 && (hasAllData || listSelected.length === maxContact || data.status == '4');
};

var travelRuleShow = function (detail, item) {
  return detail.id == item.id;
};

module.exports = {
  desensitizeEnglishName: desensitizeEnglishName,
  desensitizeCardId: desensitizeCardId,
  desensitizePhone: desensitizePhone,
  isMissing: isMissing,
  isEmployee: isEmployee,
  isExternal: isExternal,
  isMySelf: isMySelf,
  isItemChecked: isItemChecked,
  isDisableSelect: isDisableSelect,
  travelRuleShow: travelRuleShow
};